export class VNetConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mode",
            "baseName": "mode",
            "type": "VNetConfigModeEnum",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceGroupName",
            "baseName": "resourceGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "addressSpace",
            "baseName": "addressSpace",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return VNetConfig.attributeTypeMap;
    }
    constructor() {
    }
}
export var VNetConfigModeEnum;
(function (VNetConfigModeEnum) {
    VNetConfigModeEnum["Existing"] = "existing";
    VNetConfigModeEnum["Create"] = "create";
})(VNetConfigModeEnum || (VNetConfigModeEnum = {}));
